import React from "react";
import { Bar } from "react-chartjs-2";
import { Box, Paper } from "@mui/material";
import ChartDataLabels from "chartjs-plugin-datalabels";

const IndividualCombineStatsBarChart = ({
  data,
  max,
  chartType,
  chartName,
}) => {
  const isSmallDevice = window.innerWidth <= 500;

  // Calculate font size based on data length
  const dataValueLabelFontSize =
    data?.datasets?.length <= 3 ? 12 : data?.datasets?.length === 4 ? 10 : 8;

  const yTickOptions =
    chartType === "AVG"
      ? {
          ticks: {
            stepSize: 5,
            min: 0,
            suggestedMax: max || 500,
          },
          grid: {
            display: false,
          },
        }
      : {
          ticks: {
            stepSize: 15, // Set step size to 15
            ticks: {
              callback: function (value, index, values) {
                return index % 15 === 0 ||
                  index === 0 ||
                  index === values.length - 1
                  ? value
                  : null;
              },
            },
          },
          min: 0,
          max: max || 500,
          grid: {
            display: false,
          },
        };

  const options = {
    indexAxis: "x",
    scales: {
      x: {
        ticks: {
          autoSkip: false,
          maxRotation: 45,
          minRotation: 45,
          padding: 10,
        },
      },
      y: yTickOptions,
    },
    plugins: {
      legend: {
        display: true,
        labels: {
          usePointStyle: true,
        },
      },
      title: {
        display: true,
        text: chartName,
        font: {
          size: 16,
          weight: "bold",
        },
      },
      ...(isSmallDevice
        ? {}
        : {
            datalabels: {
              color: "#000",
              anchor: "end",
              align: "top",
              font: {
                weight: "bold",
                size: dataValueLabelFontSize,
              },
              formatter: (value) => (chartType === "AVG" ? value : `${value}%`),
            },
          }),
    },
    responsive: true,
    layout: {
      padding: 20,
    },
    elements: {
      bar: {
        barPercentage: 0.5,
      },
    },
    interaction: {
      intersect: false,
    },
    aspectRatio: isSmallDevice ? 1 : 1.9,
  };

  return (
    <Box mt={2} mb={2}>
      <Paper elevation={2} sx={{ backgroundColor: "#F5F5F5" }}>
        <Bar
          data={data}
          plugins={isSmallDevice ? [] : [ChartDataLabels]}
          options={options}
        />
      </Paper>
    </Box>
  );
};

export default IndividualCombineStatsBarChart;
